module.exports = __webpack_public_path__ + "static/img/inverted-quarter-pipe_256.2d4edea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inverted-quarter-pipe_256.png
// module id = 6NbT
// module chunks = 0